<template>
  <v-card id="courier-list">
    <v-card-text class="d-flex align-center flex-wrap pb-0">
      <div class="d-flex align-center pb-5">
        <v-btn
          color="primary"
          class="me-3"
          :loading="syncing"
          :disabled="hasNotPermission('Permissions.CourierSync')"
          @click="syncCouriers()"
        >
          <span>Синхронизировать</span>
        </v-btn>
      </div>

      <v-spacer></v-spacer>

      <div class="d-flex align-center pb-5">
        <v-text-field
          v-model="filters.searchQuery"
          single-line
          dense
          outlined
          hide-details
          placeholder="Поиск по ФИО и телефону..."
          class="courier-list-search me-3"
        ></v-text-field>
      </div>
    </v-card-text>

    <v-data-table
      :headers="headers"
      :items="couriers"
      :server-items-length="totalCount"
      :loading="loading"
      :page.sync="filters.pageNumber"
      :items-per-page.sync="filters.pageSize"
      :sort-by.sync="filters.sortBy"
      :sort-desc.sync="filters.sortDesc"
      :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
      :item-class="rowClass"
      class="text-no-wrap"
    >
      <template #[`item.phone`]="{item}">
        {{ item.phone || '—' }}
      </template>

      <template #[`item.isActive`]="{item}">
        <v-chip
          small
          label
          :color="item.isActive ? 'success' : 'secondary'"
          class="v-chip-light-bg"
          :class="item.isActive ? 'success--text' : 'secondary--text'"
        >
          {{ item.isActive ? 'да' : 'нет' }}
        </v-chip>
      </template>
    </v-data-table>

    <v-card-text class="text--secondary">
      Курьеров ведёт Delivery, сюда они приходят синхронизацией. Тех, кого там больше
      нет, справочник не удаляет, а выключает: на них ссылается история заказов.
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'
import { hasPermission } from '@/helpers'

export default {
  name: 'CourierList',
  computed: {
    ...mapFormHandlers('courier', [
      'filters.pageNumber',
      'filters.pageSize',
      'filters.searchQuery',
      'filters.sortBy',
      'filters.sortDesc',
    ]),
    ...mapState('courier', {
      couriers: 'list',
      totalCount: 'totalCount',
      loading: 'loading',
      syncing: 'syncing',
    }),
    headers() {
      return [
        { text: 'ФИО', value: 'fullName' },
        { text: 'Телефон', value: 'phone' },
        { text: 'Активен', value: 'isActive' },
      ]
    },
  },
  async created() {
    document.title = 'Курьеры'
    await this.fetchCouriers()
  },
  methods: {
    ...mapActions('courier', {
      fetchCouriers: 'fetchList',
      syncCouriers: 'sync',
    }),
    hasNotPermission(val) {
      return !hasPermission(val)
    },

    rowClass(item) {
      return item.isActive ? '' : 'courier-row--inactive'
    },
  },
}
</script>

<style lang="scss" scoped>
#courier-list {
  .courier-list-search {
    min-width: 17rem;
  }

  ::v-deep tbody tr.courier-row--inactive > td {
    opacity: 0.55;
  }
}
</style>
